import PdfRenderer from './PdfRenderer';

export default PdfRenderer;
